import * as React from 'react'
import { browserHistory } from 'react-router'
import { observer, inject } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { LoadingAnimation } from '../../../../components/LoadingAnimation'
import { axios } from '@getgreenline/homi-shared'
import { Routes } from '../../../../constants/Routes'

interface IProps {
  currentCompanyStore?: CurrentCompanyStore

  location: any
}

interface IState {
  errorMessage: string
}

@inject('currentCompanyStore')
@observer
export class QuickBooksAuthCallback extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      errorMessage: '',
    }
  }

  async componentDidMount() {
    const company = this.props.currentCompanyStore!.company!
    if (this.props.location.search.includes('error')) {
      this.setState({ errorMessage: 'There was an error. Please close the tab and try again' })
    } else {
      await axios.get(
        `/api/v1/company/${company.id}/quickBooks/callback${this.props.location.search}`,
      )
      await this.props.currentCompanyStore!.getById(company.id)
      browserHistory.push(Routes.DASHBOARD_INTEGRATIONS_QUICKBOOKS_ONLINE_SETTINGS(company.id))
    }
  }

  render() {
    return (
      <>{this.state.errorMessage ? <div>{this.state.errorMessage}</div> : <LoadingAnimation />}</>
    )
  }
}
